import React, { useMemo, useState, useEffect } from "react";
import CountriesComponent from "../countries";
import { useTranslation } from "react-i18next";
import Selector from "canvas-core-react/lib/Selector";

import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

import config from "../../utils/config.json";
import ErrorIcon from "../../../../static/images/error-icon.svg";
import AccountTypeSelect, { VALUE_ACCOUNT_TYPE } from "../AccountTypeSelect";
import ProviderIdType from "./providerIdType";
import CustomInput from "../custom-components/customInput";
import CustomSelect from "../custom-components/customSelect";
import { invalidPhoneNumber } from "../../utils/functions";

const currencies = config.CR.currency.reduce((acc, { name, value }) => {
  acc[value] = name;
  return acc;
}, {});

const exclude = [
  VALUE_ACCOUNT_TYPE.BNS,
  VALUE_ACCOUNT_TYPE.INT,
  VALUE_ACCOUNT_TYPE.LOCAL,
];

const FormTemplate = (props) => {
  const {
    readOnly,
    institution,
    searchInstitutions,
    deleteInstitution,
    /*  currentURL, */
    clearState,
    saveProvider,
    showToken,
  } = props;

  const { t } = useTranslation();
  const defaultProvider = props.providerOj;
  const [provider, setProvider] = useState(defaultProvider);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (
      undefined !== errors["institution"] &&
      undefined !== props.institution.companyName
    ) {
      var temError = { ...errors };
      delete temError["institution"];
      setErrors(temError);
    }
    if (props.country === "") {
      const tempProvider = {
        ...provider,
        payMethod: "",
        identification: "",
      };
      setProvider(tempProvider);
    }
  }, [props]);

  const handlerChange = (event) => {
    var tempProvider = { ...provider };
    var tempErrors = { ...errors };
    var name = event.target.name,
      value = event.target.value;

    tempProvider[name] = value;

    if (tempErrors[name] != "") {
      delete tempErrors[name];
    }

    if (name === "payMethod") {
      tempProvider.bicDestinationBank = undefined;
      delete tempErrors["bicDestinationBank"];
    }

    setErrors(tempErrors);
    setProvider(tempProvider);
  };

  const handlerSignersChange = (event, id, type) => {
    var tempProvider = { ...provider };
    // var tempErrors = { ...errors };
    var value = event.target.value;

    if (tempProvider.legalSignerWrappers[id] === undefined) {
      tempProvider.legalSignerWrappers[id] = {};
    }

    tempProvider.legalSignerWrappers[id][type] = value;

    setProvider(tempProvider);
  };

  const displayError = (id) => {
    return errors[id] !== undefined ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  };

  const clearProvider = () => {
    if (props.bscForm) {
      clearState();
    }

    setProvider({
      ...defaultProvider,
      accountIntermediaryBank: defaultProvider.accountIntermediaryBank ?? "",
      bicDestinationBank: defaultProvider.bicDestinationBank ?? "",
      bicIntermediaryBank: defaultProvider.bicIntermediaryBank ?? "",
    });

    setErrors({});
  };

  const checkSigners = () => {
    if (provider.legalSignerWrappers.length <= 0) return false;

    // At least 1
    let validElements = provider.legalSignerWrappers.filter(
      ({ signerName, signerIdentification }) =>
        !isEmpty(signerName) && !isEmpty(signerIdentification)
    );

    // Just elements with one of the two attributes are empty, if both attributes are empty ignore
    let invalidElements = provider.legalSignerWrappers.filter((item) => {
      if (
        (isEmpty(item.signerName) || isEmpty(item.signerIdentification)) &&
        !(isEmpty(item.signerName) && isEmpty(item.signerIdentification))
      ) {
        return item;
      }
    });

    // Only elements both empty allowed when 'validElements' have at least 1 element
    return validElements.length > 0 && invalidElements.length <= 0;
  };

  const isEmpty = (input) => {
    return input === undefined || input === "";
  };

  const enableActionsButton = () => {
    const providerCopy = {
      ...provider,
      accountIntermediaryBank:
        provider.accountIntermediaryBank === ""
          ? null
          : provider.accountIntermediaryBank,
      bicDestinationBank:
        provider.bicDestinationBank === "" ? null : provider.bicDestinationBank,
      bicIntermediaryBank:
        provider.bicIntermediaryBank === ""
          ? null
          : provider.bicIntermediaryBank,
    };

    if (provider.payMethod === "LOCAL" || provider.payMethod === "BNS") {
      var result =
        provider.companyName != "" &&
        provider.phone != "" &&
        provider.bankAccount != "" &&
        provider.countryId != "" &&
        provider.payMethod != "";

      return props.bySearch === true
        ? result && undefined !== institution.companyName
        : props.bscForm === true
        ? result && checkSigners()
        : JSON.stringify(providerCopy) !== JSON.stringify(defaultProvider);
    } else if (provider.payMethod === "INT") {
      var resultInt =
        provider.companyName != "" &&
        provider.phone != "" &&
        provider.bicDestinationBank != "" &&
        provider.countryId != "" &&
        provider.payMethod != "";

      return props.bySearch === true
        ? resultInt && undefined !== institution.companyName
        : props.bscForm === true
        ? resultInt && checkSigners()
        : JSON.stringify(providerCopy) !== JSON.stringify(defaultProvider);
    }

    return false;
  };

  const isFormValid = () => {
    const {
      companyName,
      phone,
      companyId,
      bankAccount,
      countryId,
      payMethod,
      bicDestinationBank,
      currency,
      identification,
      contactEmail,
      address,
      city,
      contactName,
    } = provider;
    const tempErrors = {};

    if (identification == "") {
      tempErrors["identification"] = `${t("providers.manual.errors.required")}`;
    }

    if (companyId == "") {
      tempErrors["companyId"] = `${t("providers.manual.errors.idRequired")}`;
    }

    if (identification === "DIMEX" && companyId.trim()) {
      if (companyId.length !== 12 || !/^\d+$/.test(companyId))
        tempErrors["companyId"] = `${t("providers.manual.errors.idInvalid")}`;
    }

    if (companyId.includes("%"))
      tempErrors["companyId"] = `${t(
        "providers.manual.errors.idSpecialSimbols"
      )}`;

    if (companyName == "") {
      tempErrors["companyName"] = `${t("providers.manual.errors.required")}`;
    }
    if (contactEmail == "") {
      tempErrors["contactEmail"] = `${t("providers.manual.errors.required")}`;
    }
    if (contactName == "") {
      tempErrors["contactName"] = `${t("providers.manual.errors.required")}`;
    }
    if (address == "") {
      tempErrors["address"] = `${t("providers.manual.errors.required")}`;
    }
    if (city == "") {
      tempErrors["city"] = `${t("providers.manual.errors.required")}`;
    }
    if (phone == "") {
      tempErrors["phone"] = `${t("providers.manual.errors.required")}`;
    }

    if (phone && invalidPhoneNumber(phone))
      tempErrors["phone"] = `${t("general.formErrors.invalidPhoneNumber")}`;

    if (props.bscForm) {
      if (undefined === institution.companyName) {
        tempErrors["institution"] = `${t("providers.manual.errors.required")}`;
      }
      if (
        institution &&
        (institution.businessId == companyId ||
          institution.businessId == companyId.replace(/-|_/gi, ""))
      ) {
        tempErrors["institution"] = `${t(
          "providers.manual.errors.duplicatedCompany"
        )}`;
      }
    }
    if (bankAccount == "") {
      tempErrors["bankAccount"] = `${t("providers.manual.errors.required")}`;
    }
    if (bankAccount != "" && bankAccount.length > 34) {
      tempErrors["bankAccount"] = `${t(
        "providers.manual.errors.invalidAccount"
      )}`;
    }
    if (payMethod === "INT") {
      if (!bicDestinationBank) {
        tempErrors["bicDestinationBank"] = `${t(
          "providers.manual.errors.required"
        )}`;
      }
      if (bicDestinationBank && bicDestinationBank.length > 11) {
        tempErrors["bicDestinationBank"] = `${t(
          "providers.manual.errors.bicMaxLength"
        )}`;
      }
      if (bicDestinationBank && bicDestinationBank.length < 8) {
        tempErrors["bicDestinationBank"] = `${t(
          "providers.manual.errors.bicMinLength"
        )}`;
      }
    }

    if (
      props.country === "PA" &&
      payMethod === "LOCAL" &&
      !bicDestinationBank
    ) {
      tempErrors["bicDestinationBank"] = `${t(
        "providers.manual.errors.required"
      )}`;
    }

    if (payMethod == "") {
      tempErrors["payMethod"] = `${t("providers.manual.errors.required")}`;
    }
    if (currency == "") {
      tempErrors["currency"] = `${t("providers.manual.errors.required")}`;
    }
    if (countryId == 0) {
      tempErrors["countryId"] = `${t("providers.manual.errors.required")}`;
    }

    setErrors(tempErrors);

    return Object.keys(tempErrors).length <= 0;
  };

  const save = () => {
    if (isFormValid()) {
      saveProvider({ providerInfo: provider });
    }
    return false;
  };

  const options = useMemo(() => {
    const availableOptions = (
      institution?.lineCreditCurrencyList?.map((item) => ({
        name: currencies[item],
        value: item,
      })) || []
    ).filter(({ value }) => !(provider.payMethod === "INT" && value === "CRC"));

    setProvider((prev) => ({
      ...prev,
      currency:
        options.length === 1 ? options[0].value : defaultProvider.currency,
    }));

    return availableOptions;
  }, [institution.lineCreditCurrencyList, provider.payMethod]);

  const nationalPayment =
    institution?.lineCreditCurrencyList?.length === 1 &&
    institution?.lineCreditCurrencyList?.[0] === "CRC";

  const excludePayment = !props.country
    ? exclude
    : !nationalPayment
    ? []
    : exclude.filter((val) => val === VALUE_ACCOUNT_TYPE.INT);

  const nameLabelKey = idValues.includes(provider?.identification)
    ? "fullLabel"
    : "label";

  return (
    <React.Fragment>
      <form className="manualProvider clearfix" onSubmit={save}>
        <div className="row">
          {true === props.bscForm && (
            <div className="col-lg-6">
              {undefined !== institution.companyName ? (
                <React.Fragment>
                  <div className={`search-institution provided flex-element`}>
                    {institution.companyName}
                    <div className="actions">
                      <div className="edit" onClick={searchInstitutions}></div>
                      <div className="delete" onClick={deleteInstitution}></div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <div
                  className={`search-institution missing`}
                  onClick={searchInstitutions}
                >
                  {t("providers.manual.form.institution.label")}
                </div>
              )}
              {displayError("institution")}
            </div>
          )}
          <div className="col-lg-6">
            <AccountTypeSelect
              id="payMethod"
              name="payMethod"
              onChange={handlerChange}
              disabled={readOnly}
              placeholder={t("providers.manual.form.account_type.placeholder")}
              value={provider.payMethod}
              className="select-margin-fix"
              exclude={excludePayment}
            />
            {displayError("payMethod")}
          </div>
          <div className="col-lg-6">
            <div className="form__input--inline">
              <ProviderIdType
                disabled={readOnly}
                name="identification"
                onChange={handlerChange}
                value={provider.identification}
                payMethod={provider.payMethod}
                country={props.country}
                error={errors.identification}
              />
            </div>
          </div>
          <div className="col-lg-6" style={{ marginTop: 5 }}>
            <CustomInput
              label={t("providers.manual.form.id.label")}
              name="companyId"
              autoComplete="off"
              placeholder={t("providers.manual.form.id.placeholder")}
              value={provider.companyId}
              onChange={handlerChange}
              readOnly={readOnly}
              error={errors.companyId}
            />
          </div>
          <div className="col-lg-6">
            <CustomInput
              label={t(`providers.manual.form.name.${nameLabelKey}`)}
              name="companyName"
              autoComplete="off"
              placeholder={t("providers.manual.form.name.placeholder")}
              value={provider.companyName}
              onChange={handlerChange}
              readOnly={readOnly}
              error={errors.companyName}
            />
          </div>

          <div className="col-lg-6">
            <CustomInput
              label={t("providers.manual.form.address.label")}
              name="address"
              autoComplete="off"
              placeholder={t("providers.manual.form.address.placeholder")}
              value={provider.address}
              onChange={handlerChange}
              readOnly={readOnly}
              error={errors.address}
            />
          </div>

          <div className="col-lg-6">
            <CustomInput
              label={t("providers.manual.form.city.label")}
              name="city"
              autoComplete="off"
              placeholder={t("providers.manual.form.city.placeholder")}
              value={provider.city}
              onChange={handlerChange}
              readOnly={readOnly}
              error={errors.city}
            />
          </div>

          {provider.countryName === "" || provider.countryName === null ? (
            <div className="col-lg-6">
              <div className="w-100 d-flex flex-column">
                <label
                  className={`label-default-style`}
                  style={{ color: errors.countryId ? "#cb061d" : "#333" }}
                >
                  {t("providers.manual.form.country.label")}
                </label>
                <CountriesComponent
                  name="countryId"
                  value={provider.countryId}
                  valueAttr={`id`}
                  onChange={handlerChange}
                  readOnly={readOnly}
                  placeholder={t("providers.manual.form.country.placeholder")}
                  error={errors.countryId}
                />
                {displayError("countryId")}
              </div>
            </div>
          ) : (
            <div className="col-lg-6">
              <label
                className={`label-default-style`}
                style={{ color: errors.countryId ? "#cb061d" : "#333" }}
              >
                {t("providers.manual.form.country.label")}
              </label>
              <input
                className="input input--text input-w-aux__input input--active"
                id="countryName"
                name="countryName"
                type="text"
                autoComplete="off"
                placeholder={t("providers.manual.form.country.placeholder")}
                value={provider.countryName}
                readOnly={true}
              />
            </div>
          )}
          <div className="col-lg-6">
            <CustomInput
              label={t("providers.manual.form.contact.label")}
              name="contactName"
              placeholder={t("providers.manual.form.contact.placeholder")}
              value={provider.contactName}
              onChange={handlerChange}
              readOnly={readOnly}
              error={errors.contactName}
            />
          </div>
          <div className="col-lg-6">
            <CustomInput
              label={t("providers.manual.form.phone.label")}
              name="phone"
              placeholder="88888888"
              value={provider.phone}
              onChange={handlerChange}
              readOnly={readOnly}
              error={errors.phone}
            />
          </div>
          <div className="col-lg-6">
            <CustomInput
              label={t("providers.manual.form.email.label")}
              name="contactEmail"
              placeholder="example@example.com"
              value={provider.contactEmail}
              onChange={handlerChange}
              readOnly={readOnly}
              error={errors.contactEmail}
            />
          </div>
          <div className="col-lg-6">
            <label
              className={`label-default-style`}
              style={{ color: errors.bankAccount ? "#cb061d" : "#333" }}
            >
              {t("providers.manual.form.accountNumber.label")}
            </label>
            {props.bySearch === true && props.accounts.length > 0 ? (
              <div className="form__input--inline">
                <Selector
                  id="bankAccount"
                  className="no-label"
                  label=""
                  name="bankAccount"
                  onChange={handlerChange}
                  disabled={readOnly}
                  placeholder="Seleccione un n&uacute;mero de cuenta"
                  value={provider.bankAccount}
                >
                  {props.accounts.map((account, idx) => (
                    <option
                      key={`account-${idx}`}
                      value={account.iban_account_number}
                    >
                      {account.name}
                    </option>
                  ))}
                </Selector>
              </div>
            ) : (
              <input
                className="input input--text input-w-aux__input input--active"
                id="bankAccount"
                name="bankAccount"
                type="text"
                autoComplete="off"
                placeholder={t(
                  "providers.manual.form.accountNumber.placeholder"
                )}
                value={provider.bankAccount}
                onChange={handlerChange}
                readOnly={readOnly}
              />
            )}
            {displayError("bankAccount")}
          </div>
          <div className="col-lg-6">
            <CustomSelect
              label={t("providers.manual.form.currency.label")}
              name="currency"
              onChange={handlerChange}
              disabled={readOnly || options.length === 1}
              placeholder={t("providers.manual.form.currency.placeholder")}
              value={provider.currency}
              items={options.map(({ value, name }) => ({
                value: value,
                label: name,
              }))}
              error={errors.currency}
            />
          </div>

          <div className="col-lg-6" style={{ marginTop: 5 }}>
            {provider.payMethod === "INT" ? (
              <CustomInput
                label={t("providers.manual.form.bicDestiny.label")}
                name="bicDestinationBank"
                placeholder={t("providers.manual.form.bicDestiny.placeholder")}
                onChange={handlerChange}
                error={errors.bicDestinationBank}
                value={
                  provider.payMethod === "INT"
                    ? provider.bicDestinationBank
                    : (provider.bicDestinationBank = "")
                }
                readOnly={provider.payMethod === "INT" ? readOnly : true}
              />
            ) : props.country === "PA" && provider.payMethod === "LOCAL" ? (
              <CustomSelect
                id="bicDestinationBank"
                label={t("providers.manual.form.bicDestiny.label")}
                name="bicDestinationBank"
                onChange={handlerChange}
                disabled={readOnly}
                placeholder={t("providers.manual.form.bicDestiny.placeholder")}
                value={provider.bicDestinationBank}
                items={props.achbanks.map(({ idBankShort, bankName }) => ({
                  value: idBankShort,
                  label: bankName,
                }))}
                error={errors.bicDestinationBank}
              />
            ) : (
              <CustomInput
                label={t("providers.manual.form.bicDestiny.label")}
                name="bicDestinationBank"
                placeholder={
                  provider.payMethod === "INT" ? "" : t("general.labels.na")
                }
                onChange={handlerChange}
                error={errors.bicDestinationBank}
                value={provider.bicDestinationBank}
                readOnly={true}
              />
            )}
          </div>
          <div className="col-lg-6">
            <CustomInput
              label={t("providers.manual.form.bicAccount.label")}
              name="accountIntermediaryBank"
              placeholder={
                provider.payMethod === "INT"
                  ? t("providers.manual.form.bicAccount.placeholder")
                  : t("general.labels.na")
              }
              onChange={handlerChange}
              error={errors.accountIntermediaryBank}
              value={provider.accountIntermediaryBank}
              readOnly={provider.payMethod === "INT" ? readOnly : true}
            />
          </div>
          <div className="col-lg-6">
            <CustomInput
              label={t("providers.manual.form.bicIntermediate.label")}
              name="bicIntermediaryBank"
              placeholder={
                provider.payMethod === "INT"
                  ? t("providers.manual.form.bicIntermediate.placeholder")
                  : t("general.labels.na")
              }
              onChange={handlerChange}
              error={errors.bicIntermediaryBank}
              value={provider.bicIntermediaryBank}
              readOnly={provider.payMethod === "INT" ? readOnly : true}
            />
          </div>
        </div>
        {true === props.bscForm && (
          <div className="row">
            {signers.map((item) => (
              <>
                <CustomInput
                  className="col-lg-6"
                  label={t("providers.manual.form.signersName.label")}
                  name={`signers${item + 1}`}
                  placeholder={t(
                    "providers.manual.form.signersName.placeholder"
                  )}
                  onChange={(e) => handlerSignersChange(e, item, "signerName")}
                  value={provider.legalSignerWrappers?.[item]?.signerName || ""}
                  readOnly={readOnly}
                />
                <CustomInput
                  className="col-lg-6"
                  label={t("providers.manual.form.signersId.label")}
                  name={`signersId${item + 1}`}
                  placeholder={t("providers.manual.form.signersId.placeholder")}
                  onChange={(e) =>
                    handlerSignersChange(e, item, "signerIdentification")
                  }
                  value={
                    provider.legalSignerWrappers?.[item]
                      ?.signerIdentification || ""
                  }
                  readOnly={readOnly}
                />
              </>
            ))}
          </div>
        )}
      </form>
      {!showToken && (
        <div className="form-actions clearfix">
          <SecondaryButton
            className="btnLimpiar"
            disabled={!enableActionsButton()}
            onClick={clearProvider}
          >
            {t("general.buttons.clear")}
          </SecondaryButton>
          <SecondaryButton
            id="saveProvider"
            className="btnAgregar"
            disabled={!enableActionsButton()}
            onClick={save}
          >
            {t("general.buttons.add")}
          </SecondaryButton>
        </div>
      )}
    </React.Fragment>
  );
};

export default FormTemplate;

const idValues = ["DIMEX", "PERSONAL", "01", "02", "03", "04", "05", "06"];

const signers = [0, 1, 2];
